/**
 * Project: fuse-react-app
 * FilePath: /src/client/app/sectors/DocumentViewer/DocumentViewer.config.js
 * File: DocumentViewer.config.js
 * Created Date: Wednesday, January 23rd 2019, 11:11:44 am
 * Author: Craig Bojko (craig.bojko@anexsys.com)
 * -----
 * Last Modified: Tue Jan 29 2019
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2019 Anexsys
 * ------------------------------------
 */

import { FuseLoadable } from 'modules/@fuse'
import { authRoles } from 'modules/auth'

export const DocumentViewerConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: authRoles.staff,
  routes: [{
    path: '/:projectId/documents/:documentId',
    component: FuseLoadable({
      loader: () => import('./DocumentViewer')
    })
  }]
}
